module.exports = __webpack_public_path__ + "assets/img/thumb-Earlytrade-Website.e71fd0cb.jpg";